module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-white-c43ba130404174e8af955d0706c99ba4.svg";